module.exports = __webpack_public_path__ + "media/svg/email-e3add70c.svg";